<template>
  <component :is="list.skipCardLayout?'div':'md-card'">
    <md-card-header class="md-card-header-icon md-card-header-green list-header" :class="list.hideListHeader? 'list-header-hidden' : ''">
      <template v-if="!list.hideListHeader">
        <h4 class="title">{{ list.pageTitle }}</h4>
      </template>
      
      <button v-if="list.addNewModal" v-on:click="list.showAddNewModal = true" class="md-button md-primary md-sm" style="float:right; margin-right:inherit">Add<md-icon class="md-small">control_point</md-icon></button>
      <md-button id="messageListRefresh" class="md-just-icon md-simple" @click="refresh()"><md-icon>refresh</md-icon></md-button>
    </md-card-header>

    <component
      v-if="onlyShowListIf === null || onlyShowListIf"
      :is="list.skipCardLayout?'div':'md-card-content'">
      <div class="dynamicList-loading"
        v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>
      <md-snackbar :md-position="'center'" :md-duration="4000" :md-active.sync="searchError" md-persistent>
        <span>{{searchErrorMessage}}</span><!--<md-button class="md-primary" @click="showSnackbar = false">Retry</md-button>-->
      </md-snackbar>

      <div class="_addonFilters">
        <div class="_addonFilters__filter" v-for="_filter in addonFilters" :key="_filter.id">
          <md-autocomplete 
            class="_uiKitInput"
            v-model="_filter.value" 
            :md-options="_filter.options"
            @md-changed="onAddonFilterChange($event, _filter)"
            @md-selected="onAddonFilterSelect($event, _filter)"
          >
            <label>{{ _filter.placeholder }}</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item[_filter.label] }}</template>
            <template slot="md-autocomplete-empty">No match found!</template>
          </md-autocomplete>
        </div>
      </div>

      <md-table
        :value="queriedData"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortDir"
        :md-sort-fn="customSort"
        :searchQuery="searchQuery"
        class="paginated-table table-striped table-hover"
        
      >
        <md-table-toolbar>
          <md-field :class="{ '_uiKitInput _uiKitTableInput': false !== list.searchRecordsInput }">
            <label>Search</label>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="searchQuery"
              ref="searchQuery"
              v-show="false !== list.searchRecordsInput"
            >
            </md-input>
          </md-field>

          <md-field 
            :class="{ '_uiKitInput _uiKitTableInput _uiKitTableSearch': true === list.isOfflineSearchEnabled }" 
            v-show="true !== list.isOfflineSearchHidden"
          >
            <label>Search</label>
            <md-input
              type="search"
              class="mb-3"
              clearable
              style="width: 200px"
              placeholder="Search records"
              v-model="offlineSearchQuery"
              ref="searchQuery"
              v-show="true === list.isOfflineSearchEnabled"
            >
            </md-input>
          </md-field>

          <md-field class="_uiKitInput">
            <label for="pages">Per page</label>
            <md-select v-model="currentPerPage" :key="'perPage' + activeDataName" name="pages">
              <md-option
                v-for="item in list.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </md-table-toolbar>
    
        <!-- Column Titles -->
        <md-table-row class="title-color">
          <md-table-head :key="'empty'"></md-table-head>
          <template v-for="(row, key) in list.columns">
              <md-table-head 
                :key="key" 
                class="head-cursor"
                @click.stop.native="row.sortable ? onSort(key) : null"
                @mouseenter.native="row.sortable ? hover = key : hover = ''"
                @mouseleave.native="row.sortable ? hover = '' : hover = ''" 
              >{{row.label}} 
                <md-icon
                  v-if="(row.sortable && hover === key) || lastSortByKey === key" 
                  class="md-icon-image md-theme-demo-light md-table-sortable-icn"> 
                  {{lastSortByKey === key ? (lastSortByOrder === "asc" ? 'arrow_upward' : 'arrow_downward') : 'arrow_upward'}} 
                </md-icon>
              </md-table-head>
          </template>
          <md-table-head :key="'empty1'" class="md-head-cell">Actions</md-table-head>
        </md-table-row>
        
        <template v-for="item in queriedData">
          <!-- Parent Row -->
          <md-table-row :key="item.id" @click.stop.native="list.linkRows ? (list.redirectNested ? handleRedirectNested(item) : handleEdit(item)) : false" :style="list.linkRows? 'cursor:pointer;' : ''">
            <!-- accordion icons -->
            <template v-if="item.children && item.children.items">
              <md-table-cell :key="item.id">
                <md-button 
                  class="btn-childItem" 
                  v-if="(item.isParentProduct || item.isFirstLevelParent)" 
                  @click.stop.native="toggle(item)"
                >
                  <md-icon v-if="opened.includes(item.id)">keyboard_arrow_down</md-icon>
                  <md-icon v-else>keyboard_arrow_up</md-icon>
                </md-button>
              </md-table-cell>
            </template>
            
            <template v-for="(column, key) in list.columns">
              <md-table-cell :key="key" :md-label="column.label" :md-sort-by="column.sortable? key : null">{{ `${getColumnDisplayValue(column, item, key)}` }}</md-table-cell>
            </template>
            
            <md-table-cell md-label="Actions" v-if="!list.hideActionColumn">
              <template v-if="list.itemActions">
                <template v-for="(action) in list.itemActions">
                  <md-button
                    :key="action.icon"
                    :class="item.added? action.classAdded : action.class"
                    @click.stop.native="callItemAction(action.click, item)"
                    v-show="!action.showCallback || action.showCallback(item)"
                  >
                    <md-icon>{{item.added? action.iconAdded : action.icon}}</md-icon>
                  </md-button>
                </template>
              </template>
              
              <template v-else>
                <md-button class="md-just-icon md-warning md-simple" @click.stop.native="handleEdit(item)">
                  <md-icon>description</md-icon>
                </md-button>
                <md-button v-if="$Session.isAdminGroupMember" class="md-just-icon md-danger md-simple" @click.stop.native="handleDelete(item)">
                  <md-icon>close</md-icon>
                </md-button>
              </template>
            </md-table-cell>
          </md-table-row>

          <!-- Child Row -->
          <template 
            v-for="(childItem, childKey) in (item.children ? item.children.items : [])" 
            v-show="(item.children ? item.children.items.length : 0) > 0 ? true : false"
            >
            <md-table-row 
              class="level1"
              :key="childItem.child.id + 'Level-1'" 
              v-if="opened.includes(item.id)" 
              @click.stop.native="list.linkRows ? (list.redirectNested ? handleRedirectNested(childItem.child) : handleEdit(childItem.child)) : false" 
              :style="list.linkRows? 'cursor:pointer;' : ''"
            >
              <!-- accordion icons -->
              <template>
                <md-table-cell :key="childKey">
                  <md-button 
                    class="btn-childItem" 
                    v-if="((childItem.child && childItem.child.children) ? childItem.child.children.items.length : 0) > 0" 
                    @click.stop.native="toggle1(childItem.child.id)"
                  >
                    <md-icon v-if="opened1.includes(childItem.child.id)">keyboard_arrow_down</md-icon>
                    <md-icon v-else>keyboard_arrow_up</md-icon>
                  </md-button>
                </md-table-cell>
              </template>
              
              <template v-for="(row, key) in list.columns">
                <md-table-cell :key="key">{{childItem.child[key]}}</md-table-cell>
              </template>
              
              <md-table-cell md-label="Actions" v-if="!list.hideActionColumn">
                <template v-if="list.itemActions">
                  <template v-for="(action) in list.itemActions">
                    <md-button
                      :key="action.icon"
                      :class="childItem.child.added? action.classAdded : action.class"
                      @click.stop.native="callItemAction(action.click, childItem.child)"
                      v-show="!action.showCallback || action.showCallback(childItem.child)"
                    >
                      <md-icon>{{childItem.child.added? action.iconAdded : action.icon}}</md-icon>
                    </md-button>
                  </template>
                </template>
                
                <template v-else>
                  <md-button class="md-just-icon md-warning md-simple" @click.stop.native="handleEdit(childItem.child)">
                    <md-icon>description</md-icon>
                  </md-button>
                  <md-button v-if="$Session.isAdminGroupMember" class="md-just-icon md-danger md-simple" @click.stop.native="handleDelete(childItem.child)">
                    <md-icon>close</md-icon>
                  </md-button>
                </template>
              </md-table-cell>
            </md-table-row>

            <!-- Sub Child Row -->
            <template 
              v-for="(subChildItem, subChildKey) in ((childItem.child && childItem.child.children) ? childItem.child.children.items : [])" 
              v-show="((childItem.child && childItem.child.children) ? childItem.child.children.items.length : 0) > 0 ? true : false"
              >
              <md-table-row 
                class="level2" 
                :key="subChildItem.child.id + 'Level-2'" 
                v-if="opened1.includes(childItem.child.id)" 
                @click.stop.native="list.linkRows ? (list.redirectNested ? handleRedirectNested(subChildItem.child) : handleEdit(subChildItem.child)) : false" 
                :style="list.linkRows? 'cursor:pointer;' : ''"
              >
                <template>
                  <md-table-cell :key="subChildKey"></md-table-cell>
                </template>
                <template v-for="(row, key) in list.columns">
                  <md-table-cell :key="key">{{subChildItem.child[key]}}</md-table-cell>
                </template>
                
                <md-table-cell md-label="Actions" v-if="!list.hideActionColumn">
                  <template v-if="list.itemActions">
                    <template v-for="(action) in list.itemActions">
                      <md-button
                        :key="action.icon"
                        :class="subChildItem.child.added? action.classAdded : action.class"
                        @click.stop.native="callItemAction(action.click, subChildItem.child)"
                        v-show="!action.showCallback || action.showCallback(subChildItem.child)"
                      >
                        <md-icon>{{subChildItem.child.added? action.iconAdded : action.icon}}</md-icon>
                      </md-button>
                    </template>
                  </template>
                  <template v-else>
                    <md-button class="md-just-icon md-warning md-simple" @click.stop.native="handleEdit(subChildItem.child)">
                      <md-icon>description</md-icon>
                    </md-button>
                    <md-button v-if="$Session.isAdminGroupMember" class="md-just-icon md-danger md-simple" @click.stop.native="handleDelete(subChildItem.child)">
                      <md-icon>close</md-icon>
                    </md-button>
                  </template>
                </md-table-cell>
              </md-table-row>
            </template>

          </template>
        </template>
      </md-table>
    </component>

    <md-card-actions md-alignment="space-between">
      <div class="">
        <p v-if="queriedData.length" class="card-category number">
          Showing {{ from + 1 }} to {{ from + queriedData.length }} of {{ activeData.items.length }} results fetched
        </p>
        <p v-else class="card-category">
          0 results
        </p>
      </div>
      <pagination
        v-show="queriedData.length"
        class="pagination-no-border pagination-success"
        v-model="activeData.curPage"
        :per-page="currentPerPage"
        :total="totalPages"
        :pageCount="totalPages"
        :nextToken="activeData.nextToken"
        @loadMore="loadMore"
      >
      </pagination>
    </md-card-actions>

    <!-- ATLAS-681 ElasticSearch error - no results - Alert Dialog -->
    <md-dialog-alert
      class="__alertDialog"
      :md-active.sync="mdAlertDialogShow"
      :md-title="mdAlertTitle"
      :md-content="mdAlertMessage" />

  </component>
</template>

<script>
  import RecordList from '@/mixins/RecordList';

  export default {
    mixins: [RecordList],
    props: {
      list: {
        type: Object,
        required: true
      },
      exclude: {
        type: Object,
        required: false
      },
      filter: {
        type: [Array, Object],
        required: false
      },
    },
    watch: {
      '$route.params': function () {
        if(this.$route.query.q)
          this.$refs["searchQuery"].value = this.$route.query.q
      }
    },
    created() {
      if(this.$route.query.q)
        this.searchQuery = this.$route.query.q
    },
    methods: {
      callItemAction(funcName, item) {
       if (typeof this[funcName] === 'function') {
          return this[funcName](item);
        }
        if ('function' === typeof funcName) {
          return funcName(item, this.queriedData);
        }
      },
    },
    components: {},
    data: function () {
      return {
        opened: [],
        opened1: [],
        hover: "",
      }
    },
    methods: {
      getChildItems(child) {
        Object.keys(child).forEach((key) => {
          if (child[key] === null) {
            child[key] = '';
          }
        });
        return child;
      },
      toggle(item) {
        const index = this.opened.indexOf(item.id);
        if (index > -1) {
          this.opened.splice(index, 1)
        } else {
          this.opened.push(item.id)
        }
        if (item.children) {
          item.children.items.forEach((el) => {
            const index = this.opened1.indexOf(el.child.id);
            if (index > -1) {
              this.opened1.splice(index, 1)
            } 
          })
        }
      },
      toggle1(id) {
        const index = this.opened1.indexOf(id);
        if (index > -1) {
          this.opened1.splice(index, 1)
        } else {
          this.opened1.push(id)
        }
      }
    }   
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .md-table-cell {
      overflow-wrap: break-word;
  }

  .md-head-cell {
    padding-top: 7px;
  }

  .md-table-sortable-icn {
    position: absolute;
    top: 50%;
    right: -1px;
    transition: .3s cubic-bezier(.4,0,.2,1);
    transform: translateY(-50%);
    color: rgb(54, 54, 54) !important;
  }

  .head-cursor {
    cursor: pointer;
  }

  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }

  .title-color {
    background-color: white !important;
  }
  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }

  ._addonFilters {
    display: flex;
    position: absolute;
    top: -2rem;
    left: 1.5rem;
  }
  
  .md-icon {
    font-size: 17px !important;
  }

  ._addonFilters__filter {
    width: 200px;
    margin-left: -4px;
  }
  
  ._addonFilters__filter + ._addonFilters__filter {
    margin-left: 2rem;
  }

  .md-dialog.__alertDialog.md-theme-default {
    width: 50% !important;
  }

  /* ATLAS-745 - Children Product row */
  .hidden {
    display: none !important;
  }
  tr.md-table-row.level1 {
    background-color: #E7E6E6;
  }
  tr.md-table-row.level2 {
    background-color: #C0C0C0;;
  }
  button.md-button.btn-childItem.md-theme-default {
    background-color: #fff !important;
    border: 1px solid #F6F2F2;
    border-radius: 4px;
  }
  .btn-childItem i.md-icon.md-icon-font.md-theme-default {
    color: #000 !important;
  }
</style>
